import { render, staticRenderFns } from "./appManageInterface.vue?vue&type=template&id=481998d6"
import script from "./appManageInterface.vue?vue&type=script&lang=js"
export * from "./appManageInterface.vue?vue&type=script&lang=js"
import style0 from "./appManageInterface.vue?vue&type=style&index=0&id=481998d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports